export const UPDATE_ALL = 'UPDATE_ALL';

export const BEHAVIOR_OPTIONS = {
  ADD: 'Add',
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVE_OR_DELETE: 'Archive or delete',
} as const;

export const EMPTY_LISTING = {
  address: '',
  isRoomForRent: false,
  isMultifamily: false,
  numUnits: '',
  propertyType: '',
  unit: '',
  listingAlias: '',
  customerId: '',
};

export const EMPTY_ERROR = {
  address: '',
  propertyType: '',
  unit: '',
  numUnits: '',
  customerId: '',
};

export const NUMBER_OF_UNITS_ERROR = 'Number of units must be a whole number.';
export const POSITIVE_NUMBER_OF_UNITS_ERROR = 'Number of units must be greater than 0.';
export const MAX_NUM_UNITS_VALUE = 20000;
export const MAX_NUM_UNITS_ERROR = `Number of units must be less than or equal to ${MAX_NUM_UNITS_VALUE}.`;

export const MAX_NUM_MULTIPLEX_UNITS_VALUE = 24;
export const MAX_NUM_MULTIPLEX_UNITS_ERROR = `Number of units must be less than or equal to ${MAX_NUM_MULTIPLEX_UNITS_VALUE}.`;

export const STEPS = {
  CONFIRM_ADDRESS: 'CONFIRM_ADDRESS',
  CREATE_LISTING: 'CREATE_LISTING',
  INPUT_ADDRESS: 'INPUT_ADDRESS',
  SELECT_ACTION: 'SELECT_ACTION',
  UNITS_ADDED: 'UNITS_ADDED',
  UNIT_ENTRY: 'UNIT_ENTRY',
} as const;
